<template>
  <modal :visible="visible" :toggle="toggle">

    <!-- Material type (transmitter / sensor) -->
    <div>
      <h1 class="mb-2">{{ forms.materialType.label }}</h1>
      <select v-model.number="forms.materialType.value" @change="materialTypeOnChange" class="form__input w-full">
        <option v-for="materialType in materialTypes" :key="materialType.value" :value="materialType.value" :disabled="materialType.value === 0">{{ materialType.text }}</option>
      </select>
    </div>

    <!-- Want create: Transmitter -->
    <div v-if="forms.materialType.value === materialTypes.transmitter.value" class="mt-10">
      <ValidationObserver ref="transmitterForm" v-slot="{ handleSubmit, /*invalid*/}">
        <form @submit.prevent="handleSubmit(submitTransmitterForm)">

          <div class="flex mt-2">
            <!-- Id -->
            <div class="w-64 mr-6">
              <ValidationProvider :name="forms.transmitter.id.label" rules="required|numeric|max:255|min_value:1" v-slot="{errors}">
                <label class="form__label">{{forms.transmitter.id.label }}<Required/></label>
                <input v-model="forms.transmitter.id.value" class="form__input w-full" type="number" min="1">
                <p class="form__error">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>

            <!-- TTN ID -->
            <div class="w-64">
              <ValidationProvider :name="forms.transmitter.ttnId.label" rules="required|max:255" v-slot="{errors}">
                <label class="form__label">{{ forms.transmitter.ttnId.label }}<Required/></label>
                <input v-model="forms.transmitter.ttnId.value" class="form__input w-full">
                <p class="form__error">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
          </div>

          <!-- Transmitter type -->
          <div class="w-full mt-2">
            <ValidationProvider :name="forms.transmitter.type.label" rules="required" v-slot="{errors}">
              <label class="form__label">{{ forms.transmitter.type.label }}<Required/></label>
              <!-- Waiting the transmitter types are all loaded-->
              <div v-if="transmitterTypes !== null">
                <select v-model.number="forms.transmitter.type.value" class="form__input w-full">
                  <option v-for="transmitterType in transmitterTypes" :key="transmitterType.id" :value="transmitterType.id">{{ $t('backend_trans_keys.' + transmitterType.transKey) }}</option>
                </select>
                <p class="form__error">{{ errors[0] }}</p>
              </div>
              <!-- Loading -->
              <div v-else>
                <i class="fas fa-spinner fa-spin"></i>
              </div>
            </ValidationProvider>
          </div>

          <!-- Only if we selected Weather station => fill the 4 linked sensors -->
          <div v-if="forms.transmitter.type.value === transmitterTypeWeatherStation">
            <div class="flex mt-2">
              <!-- ID Pyranometer -->
              <div class="w-64 mr-6">
                <ValidationProvider :name="forms.transmitter.pyranometer.label" rules="required|numeric|max:255|min_value:1" v-slot="{errors}">
                  <label class="form__label">{{forms.transmitter.pyranometer.label }}<Required/></label>
                  <input v-model="forms.transmitter.pyranometer.value" class="form__input w-full" type="number" min="1">
                  <p class="form__error">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>

              <!-- ID Hygrometer -->
              <div class="w-64">
                <ValidationProvider :name="forms.transmitter.hygrometer.label" rules="required|numeric|max:255|min_value:1" v-slot="{errors}">
                  <label class="form__label">{{ forms.transmitter.hygrometer.label }}<Required/></label>
                  <input v-model="forms.transmitter.hygrometer.value" class="form__input w-full">
                  <p class="form__error">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
            </div>
            <div class="flex mt-2">
              <!-- ID Barometer -->
              <div class="w-64 mr-6">
                <ValidationProvider :name="forms.transmitter.barometer.label" rules="required|numeric|max:255|min_value:1" v-slot="{errors}">
                  <label class="form__label">{{forms.transmitter.barometer.label }}<Required/></label>
                  <input v-model="forms.transmitter.barometer.value" class="form__input w-full" type="number" min="1">
                  <p class="form__error">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>

              <!-- ID Anemometer -->
              <div class="w-64">
                <ValidationProvider :name="forms.transmitter.anemometer.label" rules="required|numeric|max:255|min_value:1" v-slot="{errors}">
                  <label class="form__label">{{ forms.transmitter.anemometer.label }}<Required/></label>
                  <input v-model="forms.transmitter.anemometer.value" class="form__input w-full">
                  <p class="form__error">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
            </div>
          </div>


          <!-- Create button -->
          <button v-if="transmitterTypes !== null" class="mt-6 btn btn--success"><i class="fas fa-check mr-2"></i>{{ $t('pages.inventory.addMaterialModal.forms.validate') }}</button>
        </form>
      </ValidationObserver>
    </div>

    <!-- Want create: Sensor -->
    <div v-else-if="forms.materialType.value === materialTypes.sensor.value" class="mt-10">
      <ValidationObserver ref="sensorForm" v-slot="{ handleSubmit, /*invalid*/}">
        <form @submit.prevent="handleSubmit(submitSensorForm)">

          <div class="flex mt-2">
            <!-- Id -->
            <div class="w-64 mr-6">
              <ValidationProvider :name="forms.sensor.id.label" rules="required|numeric|max:255|min_value:1" v-slot="{errors}">
                <label class="form__label">{{ forms.sensor.id.label }}<Required/></label>
                <input v-model="forms.sensor.id.value" class="form__input w-full" type="number" min="1">
                <p class="form__error">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>

            <!-- TTN ID -->
            <div class="w-64">
              <ValidationProvider :name="forms.sensor.type.label" rules="required" v-slot="{errors}">
                <label class="form__label">{{ forms.sensor.type.label }}<Required/></label>
                <!-- Waiting the transmitter types are all loaded-->
                <div v-if="sensorTypes !== null">
                  <select v-model.number="forms.sensor.type.value" class="form__input w-full">
                    <option v-for="sensorType in sensorTypes" :key="sensorType.id" :value="sensorType.id">{{ $t('backend_trans_keys.' + sensorType.transKey) }}</option>
                  </select>
                  <p class="form__error">{{ errors[0] }}</p>
                </div>
                <!-- Loading -->
                <div v-else>
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
              </ValidationProvider>
            </div>
          </div>


          <!-- Create button -->
          <button v-if="sensorTypes !== null" class="mt-6 btn btn--success"><i class="fas fa-check mr-2"></i>{{ $t('pages.inventory.addMaterialModal.forms.validate') }}</button>
        </form>
      </ValidationObserver>
    </div>

  </modal>
</template>

<script>
import modal from "./modal";
import Required from "../forms/Required";
import {apiGetRequest, apiPostRequest, errorResponseIsFormError} from "../../utils";
import {
  API_SENSOR_TYPES_ALL,
  API_TRANSMITTER_TYPES_ALL,
  API_USERS_SENSORS_STORE,
  API_USERS_TRANSMITTERS_STORE
} from "../../utils/constants";

export default {
  name: "addMaterialModal",
  components: {modal, Required},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    userId: {
      type: [Number, String],
      required: true
    }
  },
  data: function() {
    return {
      materialTypes:{
        none: {
          text: this.$t('pages.inventory.addMaterialModal.materialTypes.none'),
          value: 0
        },
        transmitter: {
          text: this.$t('pages.inventory.addMaterialModal.materialTypes.transmitter'),
          value: 1
        },
        sensor: {
          text: this.$t('pages.inventory.addMaterialModal.materialTypes.sensor'),
          value: 2,
        }
      },
      transmitterTypes: null, // Only used for transmitter form
      sensorTypes: null, // Only used for sensor form
      transmitterTypeWeatherStation: 2,

      forms: {
        materialType: {
          label: this.$t('pages.inventory.addMaterialModal.title'),
          value: 0
        },
        transmitter: {
          id: {
            label: this.$t('pages.inventory.addMaterialModal.forms.transmitter.id'),
            value: null
          },
          ttnId: {
            label: this.$t('pages.inventory.addMaterialModal.forms.transmitter.ttnId'),
            value: null
          },
          type: {
            label: this.$t('pages.inventory.addMaterialModal.forms.transmitter.type'),
            value: null
          },
          pyranometer: {
            label: this.$t('pages.inventory.addMaterialModal.forms.transmitter.pyranometerId'),
            value: null,
          },
          hygrometer: {
            label: this.$t('pages.inventory.addMaterialModal.forms.transmitter.hygrometerId'),
            value: null,
          },
          barometer: {
            label: this.$t('pages.inventory.addMaterialModal.forms.transmitter.barometerId'),
            value: null,
          },
          anemometer: {
            label: this.$t('pages.inventory.addMaterialModal.forms.transmitter.anemometerId'),
            value: null,
          }
        },
        sensor:{
          id: {
            label: this.$t('pages.inventory.addMaterialModal.forms.sensor.id'),
            value: null
          },
          type: {
            label: this.$t('pages.inventory.addMaterialModal.forms.sensor.type'),
            value: null
          }
        }
      },
    }
  },
  methods: {
    /**
     * Callback called when a change occurred in the html material types select
     */
    materialTypeOnChange: function(){
      // Transmitter type chosen
      if(this.forms.materialType.value === this.materialTypes.transmitter.value){
        this.loadAllTransmitterTypes();
      }else if(this.forms.materialType.value === this.materialTypes.sensor.value){
        this.loadAllSensorTypes();
      }
    },
    /**
     * Fetch all available transmitter types. Fetch this data only one time if not already loaded
     */
    loadAllTransmitterTypes: function() {
      // Fetch data only one time
      if(this.transmitterTypes === null){
        apiGetRequest(API_TRANSMITTER_TYPES_ALL)
            .then((res) => {
              this.transmitterTypes = res.data
              // Set the default value to first item received
              this.forms.transmitter.type.value = this.transmitterTypes[0].id
            })
      }
    },
    /**
     * Fetch all available sensor types. Fetch this data only one time if not already loaded
     */
    loadAllSensorTypes: function() {
      // Fetch data only one time
      if(this.sensorTypes === null){
        apiGetRequest(API_SENSOR_TYPES_ALL)
            .then((res) => {
              this.sensorTypes = res.data.filter(st => !st.solderedToTransmitter) // Keep only sensor who's not soldered to transmitter (like all sensor of a weather station)
              // Set the default value to first item received
              this.forms.sensor.type.value = this.sensorTypes[0].id
            })
      }
    },
    /**
     * Called when we want to submit the transmitter form.
     * Store the new transmitter
     */
    submitTransmitterForm: function() {

      // Basic data to send
      let data = {
        id: this.forms.transmitter.id.value,
        ttnId: this.forms.transmitter.ttnId.value,
        typeId: this.forms.transmitter.type.value,
        isWeatherStation: false
      }

      // Add more elements if the chosen transmitter type is Weather Station
      if(data.typeId === this.transmitterTypeWeatherStation){
        data.isWeatherStation = true
        data.pyranometerId = this.forms.transmitter.pyranometer.value
        data.hygrometerId = this.forms.transmitter.hygrometer.value
        data.barometerId = this.forms.transmitter.barometer.value
        data.anemometerId = this.forms.transmitter.anemometer.value
      }

      apiPostRequest(API_USERS_TRANSMITTERS_STORE(this.userId), data)
          .then(() => {
            // Emit an event to notify the transmitter creation
            this.$emit("newTransmitterCreated", this.forms.transmitter.id.value)
            // Reset the form and toggle modal
            this.forms.materialType.value = 0
            this.forms.transmitter.id.value = null
            this.forms.transmitter.ttnId.value = null
            this.forms.transmitter.type.value = this.transmitterTypes[0].id
            this.toggle()
          })
          .catch((e) => {
            // Add custom error message for errors that comes from the backend checks
            if(errorResponseIsFormError(e)){
              const errors = {}
              const uniqueErrorLabel = this.$t('pages.inventory.addMaterialModal.forms.uniqueError')
              const distinctErrorLabel = this.$t('pages.inventory.addMaterialModal.forms.distinctIdsError')
              for (const errorKey in e.response.data.fields) {
                // Error when id already exists
                if(e.response.data.fields[errorKey] === 'unique'){
                  switch (errorKey) {
                    case "id":
                      errors[this.forms.transmitter.id.label] = uniqueErrorLabel
                      break
                    case "ttnId":
                      errors[this.forms.transmitter.ttnId.label] = uniqueErrorLabel
                      break
                    case "pyranometerId":
                      errors[this.forms.transmitter.pyranometer.label] = uniqueErrorLabel
                      break
                    case "hygrometerId":
                      errors[this.forms.transmitter.hygrometer.label] = uniqueErrorLabel
                      break
                    case "barometerId":
                      errors[this.forms.transmitter.barometer.label] = uniqueErrorLabel
                      break
                    case "anemometerId":
                      errors[this.forms.transmitter.anemometer.label] = uniqueErrorLabel
                      break
                  }
                }
                // Error for weather station sensors, all 4 ids must be different each other
                else if(e.response.data.fields[errorKey] === 'distinct') {
                  if(errorKey === 'weatherStationSensors'){
                    errors[this.forms.transmitter.pyranometer.label] = distinctErrorLabel
                    errors[this.forms.transmitter.hygrometer.label] = distinctErrorLabel
                    errors[this.forms.transmitter.barometer.label] = distinctErrorLabel
                    errors[this.forms.transmitter.anemometer.label] = distinctErrorLabel
                  }
                }
              }
              this.$refs.transmitterForm.setErrors(errors)
            } else {
              this.toggle()
            }
          })
    },
    /**
     * Called when we want to submit the sensor form
     * Store the new sensor
     */
    submitSensorForm: function() {
      apiPostRequest(API_USERS_SENSORS_STORE(this.userId), {
        id: this.forms.sensor.id.value,
        typeId: this.forms.sensor.type.value
      })
          .then(() => {
            // Emit an event to notify the sensor creation
            this.$emit("newSensorCreated", this.forms.sensor.id.value)
            // Reset the form and toggle modal
            this.forms.materialType.value = 0
            this.forms.sensor.id.value = null;
            this.forms.sensor.type.value = this.sensorTypes[0].id
            this.toggle()
          })
          .catch((e) => {
            // Add custom error message for fields that must be unique in DB
            if(errorResponseIsFormError(e)){
              const errors = {}
              for (const errorKey in e.response.data.fields) {
                if(errorKey === "id" && e.response.data.fields[errorKey] === 'unique'){
                  errors[this.forms.sensor.id.label] = this.$t('pages.inventory.addMaterialModal.forms.uniqueError')
                }
              }
              this.$refs.sensorForm.setErrors(errors)
            } else {
              this.toggle()
            }
          })
    }
  }
}
</script>

<style scoped>

</style>
